<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.shared')}}</div>
    <div slot="body">
      <!-- <a-alert class="mb-2" type="warning" :message="$t('bill.ignore_tips')" /> -->
      <dialog-selected-tips :count="params.data.length" :action="$t('bill.shared')" :name="$t('bill.cpp')" />
      <dialog-table :data="params.data" :columns="columns" />
      <a-form :form="form.fc" hideRequiredMark v-bind="formItemLayout">
        <a-row v-for="(sharedItem, index) in sharedList" :key="index">
        <a-col :span="12">
          <a-form-item :label="$t('bill.project')">
            <base-select
              v-if="hasFullShared"
              v-model="sharedItem[0]"
              style="width:300px"
              isDefaultSelect
              :params="{...projectParams, $t: index + 1}"
              :filterable="true"
              :options="projectExtraOpts"
              :select-props="{ placeholder: $t('cloudenv.text_551') }"
              @update:item="(val)=>{projectChange(index,val.id)}">
              <template #optionLabelTemplate="{ item }">
                {{ item.name }}
              </template>
            </base-select>
            <base-select
              v-else
              v-model="sharedItem[0]"
              resource="projects"
              style="width:300px"
              remote
              needParams
              isDefaultSelect
              :params="{...projectParams, $t: index + 1}"
              :filterable="true"
              :extra-opts="projectExtraOpts"
              :select-props="{ placeholder: $t('cloudenv.text_551') }"
              @update:item="(val)=>{projectChange(index,val.id)}">
              <template #optionLabelTemplate="{ item }">
                {{ item.name }}
              </template>
            </base-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('bill.count')">
            <a-input-number
             v-model="sharedItem[1]"
             class="ml-1"
             style="width:160px"
             @change="(val)=>{sharedNumChange(index,val)}" />
            <a-button v-if="sharedList.length > 1 && !hasFullShared" style="display:inline-block;margin-left: 20px" shape="circle" icon="minus" size="small" @click="deleteShared(index)" />
          </a-form-item>
        </a-col>
      </a-row>
      </a-form>
      <div class="d-flex align-items-center mt-2" v-if="addShow && !hasFullShared">
        <a-button type="primary" shape="circle" icon="plus" size="small" @click="add" />
        <a-button type="link" @click="add">{{$t('bill.add_project')}}</a-button>
      </div>
    </div>
    <div slot="footer">
      <a-tooltip v-if="!hasFullShared" :title="isFullShared?'':$t('bill.cpp_shared_tooltip')" placement="left" class="mr-2">
        <a-button type="primary" @click="handleConfirm" :loading="loading" :disabled="!isFullShared">{{ $t('dialog.ok') }}</a-button>
      </a-tooltip>
      <span />
      <a-button v-if="!hasFullShared" @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
      <a-button v-else @click="cancelDialog" type="primary">{{ $t('dialog.ok') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
// import expectStatus from '@/constants/expectStatus'

export default {
  name: 'CppSharedDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { projects_cpp = [{ project_id: '', cpp_count: 1 }] } = this.params.data[0]
    const defaultShared = projects_cpp.map(item => {
      return [item.project_id, item.cpp_count]
    })
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        project:
          [
            'project',
            { required: true },
          ],

      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      sharedList: defaultShared,
      projectParams: {
        domain_id: this.params.domain_id,
        limit: 20,
      },
    }
  },
  computed: {
    ...mapGetters(['scope']),
    columns () {
      const showFields = ['category', 'reservation_years', 'cpp_count']
      return this.params.columns.filter((item) => { return showFields.includes(item.field) })
    },
    help () {
      return ''
    },
    cppCount () {
      return this.params.data[0].cpp_count || 0
    },
    addShow () {
      let len = 0
      this.sharedList.map(item => {
        len += item[1]
      })
      return len < this.cppCount
    },
    isFullShared () {
      let len = 0
      this.sharedList.map(item => {
        len += item[1]
      })
      return len === this.cppCount
    },
    hasFullShared () {
      const { cpp_shared_status } = this.params.data[0]
      return cpp_shared_status === 100
    },
    projectExtraOpts () {
      const projectList = []
      const { projects_cpp = [] } = this.params.data[0]
      projects_cpp.map(item => {
        const filterProjects = projectList.filter(project => project.id === item.project_id)
        if (!filterProjects.length) projectList.push({ id: item.project_id, name: item.project })
      })
      return projectList
    },
  },
  created () {
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      const manager = new this.$Manager('reservations', 'v1')
      try {
        await this.form.fc.validateFields()
        const projects_cpp = []
        this.sharedList.map(item => {
          projects_cpp.push({
            project_id: item[0],
            cpp_count: item[1],
          })
        })
        await manager.performAction({
          id: this.params.resId,
          action: 'setprojects',
          data: {
            projects_cpp,
          },
        })
        this.params.refresh && this.params.refresh()
        this.cancelDialog()
        this.$message.success(this.$t('compute.text_423'))
      } finally {
        this.loading = false
      }
    },
    sharedNumChange (index, val) {
      val = parseInt(val)
      // 最大值校验，所有加起来不超过总数
      let restAll = 0
      this.sharedList.map((item, idx) => {
        if (idx !== index) {
          restAll += item[1]
        }
      })
      if (restAll + val > this.cppCount) {
        val = this.cppCount - restAll
      }
      // 非常规值校验
      if (val < 1) {
        val = 1
      }
      this.sharedList[index] = [this.sharedList[index][0], val]
      this.sharedList = R.clone(this.sharedList)
    },
    projectChange (index, val) {
      this.sharedList[index] = [val, this.sharedList[index][1]]
      this.sharedList = R.clone(this.sharedList)
    },
    add () {
      this.sharedList = [...this.sharedList, ['', 1]]
    },
    deleteShared (index) {
      this.sharedList = this.sharedList.filter((item, idx) => idx !== index)
    },
  },
}
</script>
